module.exports = __webpack_public_path__ + "static/media/climate_background_bottom_left.1ad75e44.svg";